import apiClient from './client';

export interface ScheduleEvent {
  id: number | string;
  job_id: number;
  jobId: number;
  job_number?: string;
  jobNumber: string;
  job_title?: string;
  jobTitle: string;
  crew_id?: number;
  crewId?: number;
  crew_name?: string;
  crewName?: string;
  client_name?: string;
  clientName?: string;
  site_address?: string;
  siteAddress?: string;
  scheduled_date: string;
  scheduledDate: string;
  start_time?: string;
  startTime?: string;
  end_time?: string;
  endTime?: string;
  status: 'scheduled' | 'in_progress' | 'completed' | 'cancelled';
  notes?: string;
  created_at?: string;
  updated_at?: string;
  end_date?: string;
  endDate?: string;
  subtasks?: any[];
  parent_task_id?: number | string;
  parentTaskId?: number | string;
}

export interface UnassignedJob {
  id: number;
  job_number: string;
  jobNumber: string;
  title: string;
  site_address?: string;
  siteAddress?: string;
  client_name?: string;
  clientName?: string;
  status: string;
}

export interface ConflictCheck {
  hasConflict: boolean;
  conflicts: ScheduleEvent[];
}

export const getScheduleEvents = async (params?: {
  startDate?: string;
  endDate?: string;
  crewId?: number | string;
  jobId?: number | string;
}): Promise<ScheduleEvent[]> => {
  const response = await apiClient.get('/schedule/events', { params });
  return response.data.data;
};

export const getScheduleEventsByJob = async (jobId: string | number): Promise<ScheduleEvent[]> => {
  const response = await apiClient.get('/schedule/events', { 
    params: { jobId } 
  });
  return response.data.data;
};

export const getUnassignedJobs = async (): Promise<UnassignedJob[]> => {
  const response = await apiClient.get('/schedule/unassigned');
  return response.data.data;
};

export const createScheduleEvent = async (data: {
  jobId: number;
  crewId?: number;
  scheduledDate: string;
  startTime?: string;
  endTime?: string;
  notes?: string;
}): Promise<{ id: number }> => {
  const response = await apiClient.post('/schedule/events', data);
  return response.data.data;
};

export const updateScheduleEvent = async (
  id: number | string,
  data: {
    crewId?: number;
    scheduledDate?: string;
    endDate?: string;
    startTime?: string;
    endTime?: string;
    status?: string;
    notes?: string;
  }
): Promise<void> => {
  await apiClient.put(`/schedule/events/${id}`, data);
};

export const deleteScheduleEvent = async (id: number | string): Promise<void> => {
  await apiClient.delete(`/schedule/events/${id}`);
};

export const updateChecklistItem = async (id: number, checked: boolean): Promise<void> => {
  await apiClient.patch(`/schedule/checklist/${id}`, { checked });
};

export const notifyScheduleEvent = async (
  id: number | string,
  message?: string
): Promise<{ emailed: boolean; emailTo?: string; reason?: string }> => {
  const response = await apiClient.post(`/schedule/events/${id}/notify`, message ? { message } : {});
  return response.data || { emailed: false };
};

export const assignJobToCrew = async (data: {
  jobId: number;
  crewId: number;
  scheduledDate: string;
  startTime?: string;
  endTime?: string;
}): Promise<{ id: number; conflict: boolean }> => {
  const response = await apiClient.post('/schedule/assign', data);
  return response.data.data;
};

export const checkScheduleConflicts = async (params: {
  crewId: number;
  scheduledDate: string;
  startTime?: string;
  endTime?: string;
  excludeId?: number;
}): Promise<ConflictCheck> => {
  const response = await apiClient.get('/schedule/conflicts', { params });
  return response.data.data;
};
